import axios from "axios";
import { API_BASE, PUBLIC_TENANT } from "./publicEventsApi";

/**
 * Ticketabruf
 * ===========
 *
 * Der Client nennt nur UNSERE Event-ID. Welcher Anbieter dahintersteht, welche
 * Feldnamen dessen Antwort benutzt und ob es ueberhaupt eine Anbindung gibt,
 * entscheidet der pyserver.
 *
 * Vorher stand die Anbieterzuordnung hier im Browser. Das war der falsche Ort:
 * Anbieterwissen gehoert auf den Server -- sonst reicht der Client fremde
 * Kennungen herum und jede neue Quelle braucht ein neues Frontend-Deployment.
 */

/**
 * Ticketkategorien fuer einen Event-Baustein holen.
 *
 * Wirft mit dem Wortlaut des Servers statt still eine leere Liste
 * zurueckzugeben -- "Anbieter nicht erreichbar" und "keine Plaetze" sind fuer
 * den Reisenden zwei verschiedene Dinge.
 */
export async function fetchTicketCategories(part) {
  const eventId = part?.id;
  if (!eventId) throw new Error("Kein Event gewählt.");

  const url = `${API_BASE}/searchpublicevents/${encodeURIComponent(eventId)}/tickets`;
  const res = await axios.get(url, { params: { tenant_id: PUBLIC_TENANT } });
  const body = res.data || {};

  // StandardResponse liefert HTTP 200 auch im Fehlerfall, der Code steht im
  // Body. Der Statuscode allein beweist hier nichts.
  if (body.code && body.code !== 200) {
    throw new Error(body.msg || `Anbieter meldet Code ${body.code}`);
  }

  return body.data?.categories || [];
}
